import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { GOOGLE_MAPS_KEY } from './config';

// Loads Google's official Maps JS API + the GoogleMutant Leaflet plugin once,
// then lets us show Google tiles (satellite/roadmap) inside our Leaflet map.
let loader = null;
function ensureGoogle() {
  if (window.L && L.gridLayer && L.gridLayer.googleMutant) return Promise.resolve();
  if (loader) return loader;
  const script = (src) => new Promise((res, rej) => {
    const s = document.createElement('script');
    s.src = src; s.async = true; s.onload = res; s.onerror = () => rej(new Error('load failed'));
    document.head.appendChild(s);
  });
  loader = script(`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_KEY}&v=weekly`)
    .then(() => script('https://unpkg.com/leaflet.gridlayer.googlemutant@0.14.0/dist/Leaflet.GoogleMutant.js'));
  return loader;
}

// styles: optional Google map styling (e.g. a muted roadmap) — same tiles, calmer look.
export default function GoogleMutantLayer({ type = 'hybrid', styles = null }) {
  const map = useMap();
  const layerRef = useRef(null);
  useEffect(() => {
    let cancelled = false;
    ensureGoogle().then(() => {
      if (cancelled) return;
      layerRef.current = L.gridLayer.googleMutant({ type, ...(styles ? { styles } : {}) }); // hybrid | satellite | roadmap | terrain
      layerRef.current.addTo(map);
    }).catch(() => { /* billing not active yet or offline — layer just stays empty */ });
    return () => { cancelled = true; if (layerRef.current) { map.removeLayer(layerRef.current); layerRef.current = null; } };
  }, [type, styles, map]);
  return null;
}
